import React from 'react';
import CommonPersonal from './CommonPersonal';

const Personal = () => {
    return (
        <div>
            <CommonPersonal items={12} condition={true}/>
        </div>
    );
};

export default Personal;